import { IApplicationState } from '../../types/redux';

export function getEcology(state: IApplicationState) {
  return state.newbuilding.ecology;
}
